import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Row = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, noGutters } = _a, attributes = __rest(_a, ["as", "className", "noGutters"]);
    const classes = clsx(className, noGutters ? 'no-gutters' : null, 'row');
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
Row.displayName = 'Row';
export { Row };
//# sourceMappingURL=Row.js.map